import React, { createContext, useContext, useState } from 'react';
import { jwtDecode } from 'jwt-decode';

const UserContext = createContext(null);

export function UserProvider({ children }) {
  const [user, setUser] = useState(() => {
    const token = sessionStorage.getItem('accessToken');
    if (!token) return null;
    try { return jwtDecode(token); } catch { return null; }
  });

  const login = (token) => {
    sessionStorage.setItem('accessToken', token);
    setUser(jwtDecode(token));
  };

  const logout = () => {
    sessionStorage.clear();
    setUser(null);
  };

  const updateUser = (fields) => setUser(u => ({ ...u, ...fields }));

  return (
    <UserContext.Provider value={{ user, login, logout, updateUser }}>
      {children}
    </UserContext.Provider>
  );
}

export const useUser = () => useContext(UserContext);